import styled, { StyledComponentBase } from 'styled-components'
import theCat from './../../../assets/welcome/the_cat.png'
import theCat2x from './../../../assets/welcome/the_cat@2x.png'
import theCat3x from './../../../assets/welcome/the_cat@3x.png'
import logo from './../../../assets/logo.svg'

interface IHeaderWelcome extends StyledComponentBase<any, {}> {
	CatImg?: any
	Inner?: any
	Logo?: any
	LogoBox?: any
}

const HeaderWelcome: IHeaderWelcome = styled.header`
	position: relative;
`

HeaderWelcome.CatImg = styled.img.attrs(() => {
	return {
		srcSet: `${theCat}, ${theCat2x}, ${theCat3x}`,
		src: `${theCat}`,
		alt: 'Pic',
	}
})`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	object-fit: contain;
`

HeaderWelcome.Inner = styled.div`
	height: 6.25rem;
	padding-right: 6rem;
	border-bottom: 1px solid #70707040;
`

HeaderWelcome.LogoBox = styled.div`
	position: absolute;
	bottom: -1.7rem;
	background-color: #ffffff;
	padding: 0 1.5625rem;
	left: calc(50% - 4rem);
	z-index: 1;
`

HeaderWelcome.Logo = styled.img.attrs(() => {
	return {
		src: `${logo}`,
		alt: 'Dariohealth',
	}
})`
	width: 4.8125rem;
	height: 5.625rem;
	object-fit: contain;
`

export { HeaderWelcome }
